import React from 'react';
import { Card, CardBody, CardHeader, Col } from 'reactstrap';
import { H5 } from '../../../AbstractElements';
import ReactApexChart from 'react-apexcharts';

const UserQLTDistribution = ({ usersQLT = [], loading }) => {
  // Tính toán phân phối user theo các tiêu chí
  const getDistributionData = () => {
    if (!usersQLT || usersQLT.length === 0) {
      return {
        series: [0, 0, 0, 0],
        labels: ['Followed OA', 'Not Followed', 'With Pharmacy', 'Without Pharmacy']
      };
    }

    const total = usersQLT.length;
    const followedOA = usersQLT.filter(user => user.followedOA === true).length;
    const notFollowed = total - followedOA;
    const withPharmacy = usersQLT.filter(user => user.pharmacyName && user.pharmacyName !== '').length;
    const withoutPharmacy = total - withPharmacy;

    return {
      series: [followedOA, notFollowed, withPharmacy, withoutPharmacy],
      labels: ['Followed OA', 'Not Followed', 'With Pharmacy', 'Without Pharmacy']
    };
  };

  const distributionData = getDistributionData();

  const chartOptions = {
    chart: {
      type: 'donut',
      height: 350
    },
    labels: distributionData.labels,
    colors: ['#7366ff', '#f73164', '#51bb25', '#ffc107'],
    plotOptions: {
      pie: {
        donut: {
          size: '70%',
          labels: {
            show: true,
            total: {
              show: true,
              label: 'Total Users',
              formatter: () => usersQLT.length || 0
            }
          }
        }
      }
    },
    legend: {
      position: 'bottom'
    },
    responsive: [{
      breakpoint: 480,
      options: {
        chart: {
          width: 200
        },
        legend: {
          position: 'bottom'
        }
      }
    }]
  };

  if (loading) {
    return (
      <Col xxl="6" className="box-col-6">
        <Card>
          <CardBody className="d-flex justify-content-center align-items-center" style={{ height: '400px' }}>
            <div className="text-center">
              <p>Đang tải biểu đồ phân phối...</p>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }

  return (
    <Col xxl="6" className="box-col-6">
      <Card>
        <CardHeader className="card-no-border">
          <H5>User Distribution</H5>
        </CardHeader>
        <CardBody>
          <ReactApexChart
            options={chartOptions}
            series={distributionData.series}
            type="donut"
            height={350}
          />
        </CardBody>
      </Card>
    </Col>
  );
};

export default UserQLTDistribution;

